import { isActiveSession } from './robotRoundContract';
import { readRobotRoundSession, writeRobotRoundSession } from './robotRoundStorage';

export function recordRobotRoundEvent({ enabled, uid, event } = {}) {
  if (enabled !== true || !uid || !event) return false;
  const session = readRobotRoundSession(uid);
  if (!isActiveSession(session)) return false;
  return writeRobotRoundSession({
    ...session,
    events: [...session.events, { ...event, timestamp: event.timestamp || new Date().toISOString() }],
  }, uid);
}
